webpackJsonp([28767283783575],{

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.IowaImageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _HeroSmall = __webpack_require__(8);
	
	var _HeroSmall2 = _interopRequireDefault(_HeroSmall);
	
	var _LocationMicroNav = __webpack_require__(10);
	
	var _LocationMicroNav2 = _interopRequireDefault(_LocationMicroNav);
	
	var _LocationContent = __webpack_require__(9);
	
	var _LocationContent2 = _interopRequireDefault(_LocationContent);
	
	var _LocationRelated = __webpack_require__(11);
	
	var _LocationRelated2 = _interopRequireDefault(_LocationRelated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IowaLocation = function (_React$Component) {
	  _inherits(IowaLocation, _React$Component);
	
	  function IowaLocation() {
	    _classCallCheck(this, IowaLocation);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  IowaLocation.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_HeroSmall2.default, { location: 'Iowa' }),
	      _react2.default.createElement(_LocationMicroNav2.default, null),
	      _react2.default.createElement(_LocationContent2.default, {
	        category: 'Promoting Ridership',
	        title: 'Over the River and Through the Woods',
	        story: 'RAGBRAI (Register\u2019s Annual Great Bicycle Ride Across Iowa) is one of the oldest, largest and longest recreational bicycle touring events in the world. So it was truly an honor to take the stage during this epic event and spend a day riding across the hills of Iowa. While the route is different each year, one constant is RAGBRAI\u2019s support of PeopleForBikes. Our simple message to the more than 10,000 riders from all 50 states: If you love bike riding, and if you love RAGBRAI, the best thing to do is join PeopleForBikes so you can speak up for bicycling when we call on our members. '
	      }),
	      _react2.default.createElement(_gatsbyImage2.default, {
	        title: 'Iowa 1-1',
	        alt: 'RAGBRAI (Register\u2019s Annual Great Bicycle Ride Across Iowa)',
	        sizes: this.props.data.iowaOneOneImage.sizes
	      }),
	      _react2.default.createElement(_LocationRelated2.default, {
	        prevLocationName: 'Memphis, TN',
	        prevLocationPath: 'memphis',
	        prevLocationImgPath: this.props.data.iowaPrevImage,
	        nextLocationName: 'Arlington, VA',
	        nextLocationPath: 'arlington',
	        nextLocationImgPath: this.props.data.iowaNextImage
	      })
	    );
	  };
	
	  return IowaLocation;
	}(_react2.default.Component);
	
	exports.default = IowaLocation;
	
	// GraphQL query
	
	var IowaImageQuery = exports.IowaImageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-iowa-js-ec18282c470c9c2769c9.js